export const funderIdentifierTypes = [
  {label: 'ISNI', value: 'ISNI'},
  {label: 'GRID', value: 'GRID'},
  {label: 'CrossRef Funder', value: 'CROSS_REF_FUNDER'},
  {label: 'Other', value: 'OTHER'}
]
